/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreTimesheetResponseDto } from '../../models/core-timesheet-response-dto';
import { CoreTimesheetUpdateDto } from '../../models/core-timesheet-update-dto';

export interface TimesheetsControllerUpdate$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Timesheet ID
 */
  id: string;
      body: CoreTimesheetUpdateDto
}

export function timesheetsControllerUpdate(http: HttpClient, rootUrl: string, params: TimesheetsControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreTimesheetResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, timesheetsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreTimesheetResponseDto>;
    })
  );
}

timesheetsControllerUpdate.PATH = '/o2-core/timesheets/{tenant}/id/{id}';
